

export const BaseUrl = 'https://admin.foodweb-impala.ksoftpl.com/api';
export const AssetsUrl = 'https://admin.foodweb-impala.ksoftpl.com'; 

global.BaseUrl = 'https://admin.foodweb-impala.ksoftpl.com/api';
global.AssetsUrl = 'https://admin.foodweb-impala.ksoftpl.com';


